import { useCallback, useEffect, useRef, useState } from 'react';
import { api, errMsg } from '../lib/api';

export const usePaymentResource = (path, interval = 0) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(!!path);
  const version = useRef(0);
  const pending = useRef(false);
  const loadedPath = useRef(null);
  const reload = useCallback(async () => {
    if (!path || pending.current) return;
    const generation = version.current;
    pending.current = true;
    try { const response = await api.get(path); if (generation === version.current) { loadedPath.current = path; setData(response.data); setError(''); } return response.data; }
    catch (failure) { if (generation === version.current) setError(errMsg(failure)); }
    finally { if (generation === version.current) { pending.current = false; setLoading(false); } }
  }, [path]);
  useEffect(() => {
    version.current += 1; pending.current = false; setData(null); setError(''); setLoading(!!path); reload();
    const timer = interval && path ? setInterval(() => { if (!document.hidden) reload(); }, interval) : null;
    const focus = () => reload(); window.addEventListener('focus', focus);
    return () => { version.current += 1; pending.current = false; if (timer) clearInterval(timer); window.removeEventListener('focus', focus); };
  }, [path, interval, reload]);
  const updateData = useCallback(value => { version.current += 1; pending.current = false; loadedPath.current = path; setData(value); setError(''); setLoading(false); }, [path]);
  return { data: loadedPath.current === path ? data : null, setData: updateData, error, loading, reload };
};